import type SessionService from '@efdigital/ll-addon-auth/services/session';
import type Owner from '@ember/owner';
import { getOwner, setOwner } from '@ember/owner';
import type { Future, Handler, NextFn } from '@warp-drive/core/request';
import type {
  RequestContext,
  StructuredDataDocument,
} from '@warp-drive/core/types/request';

class AuthHandler implements Handler {
  request<T = unknown>(
    context: RequestContext,
    next: NextFn<T>
  ): Promise<T | StructuredDataDocument<T>> | Future<T> {
    const headers = new Headers(context.request.headers);
    const owner = getOwner(this);
    const session = owner?.lookup('service:session') as
      | SessionService
      | undefined;
    if (session) {
      return session.getCurrent().then((currentState) => {
        const token = currentState?.data?.authenticated?.accessToken;
        if (token) {
          headers.set('Authorization', `Bearer ${token}`);
        }
        return next({ ...context.request, headers });
      });
    }
    return next({ ...context.request, headers });
  }
}

export function initializeAuthHandler(owner: Owner) {
  setOwner(authHandler, owner);
}

export const authHandler = new AuthHandler();
